<template>
    <div class="center row-column acea-row row-center-wrapper">
            <div class="btn">应用场景</div>
            <div class="img_list row-center-wrapper acea-row" >
                <viewer  style="width: 45%;padding:20px" v-for="(item,index) in dataList" :key="index">
                    <img :src="item.img" class="img"/>
                </viewer>
            </div>
    </div>
</template>
<script>
export default {
  props:["dataList"],
  name: "applicationScene",
  data() {
    return {
    };
  },
  watch: {},
  components: {
  },
  mounted: function () {
      this.dataList=this.dataList;
  },
};
</script>
<style  scoped>
.center{
    padding: 30px 30px 30px 30px;
    background-color: #fff;
    border-radius: 30px;
    width: 100%;
    margin-bottom: 40px;
    margin-top: 20px;
}
.center .btn{
    padding: 8px 40px;
    border-radius: 40px;
    color: #555555;
    font-size: 24px;
    border: #E7E7E7 solid 1px;
}
.center .img_list{
    width: 100%;
    margin-top: 20px;
}
.center .img_list .img{
    width: 100%;
    height: 37%;
}
/* 处理移动端 */
@media screen and (max-width: 850px) {
    .center{
        width: 100%;
    }
    .center .img_list .img{
        /* width: 42%; */
        height: 37%;
        margin:20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/programme/applicationScene.vue